import { createSelector } from 'reselect';

// The Personalizar settings blob already comes back on the empresaTemplate row loaded by
// getAppTemplateData() (see application-reducer.js's setTemplateData) — no separate fetch.
const getApplicationState = (state) => state?.applicationState;

export const selectBrandingSettings = createSelector(
  [getApplicationState],
  (applicationState) => applicationState?.brandingSettings ?? null
);

// The only "has this agency published the new hero/header" signal — see MUN-2237 plan.
export const selectHasPublishedBranding = createSelector(
  [selectBrandingSettings],
  (settings) => settings != null
);
